/**
 * Les AVANCES des polices mathématiques, en millièmes de cadratin, et la
 * métrique que le manuel en tire.
 *
 * FICHIER ENGENDRÉ — par la mesure des fichiers de police embarqués
 * (table `hmtx`), jamais à la main. Une chasse PROPORTIONNELLE ne se
 * calcule pas : elle se lit dans la police, une fois, et se range ici pour
 * que `disposerMath` reste une fonction pure et sans dépendance.
 */
import { metriqueProportionnelle } from './metrique.js';
const AVANCES_DROIT = {
    caracteres: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u00c0\u00c2\u00c4\u00c7\u00c9\u00c8\u00ca\u00cb\u00ce\u00cf\u00d4\u00d6\u00d9\u00db\u00dc\u0178\u00e0\u00e2\u00e4\u00e7\u00e9\u00e8\u00ea\u00eb\u00ee\u00ef\u00f4\u00f6\u00f9\u00fb\u00fc\u00ff\u0153\u0152\u00e6\u00c6\u00a0\u202f\u2009\u00ab\u00bb\u2019\u2018\u201c\u201d\u2026\u2014\u2013\u00b0\u2032\u2033\u2212\u00b7\u00d7\u00f7\u00b1=<>\u03c0\u00b5\u03b1\u03b2\u03b8\u0394\u0398\u00b2\u00b3\u00b9\u2070\u2074\u2075\u2076\u2077\u2078\u2079\u207f',
    avances: [
        235, 297, 338, 573, 495, 716, 736, 189, 362, 362, 415, 730, 255, 315, 255, 396, 495, 495, 495,
        495, 495, 495, 495, 494, 495, 495, 255, 255, 711, 730, 711, 427, 915, 728, 635, 675, 741, 637,
        597, 726, 798, 372, 419, 729, 605, 927, 759, 740, 594, 740, 681, 512, 621, 767, 689, 976, 675,
        656, 602, 362, 394, 362, 480, 512, 222, 495, 537, 461, 556, 480, 324, 499, 597, 299, 278, 564,
        297, 882, 598, 525, 552, 539, 402, 409, 336, 589, 496, 780, 495, 498, 470, 333, 275, 333, 570,
        728, 728, 728, 675, 637, 637, 637, 637, 372, 372, 740, 740, 767, 767, 767, 656, 495, 495, 495,
        461, 480, 480, 480, 480, 298, 298, 525, 525, 589, 589, 589, 498, 820, 965, 725, 913, 235, 125,
        125, 533, 533, 247, 247, 441, 441, 919, 1000, 500, 413, 305, 472, 730, 291, 669, 607, 730, 730,
        711, 711, 592, 561, 562, 531, 515, 694, 747, 375, 377, 350, 426, 418, 363, 404, 366, 380, 404,
        503,
    ],
};
const AVANCES_ITALIQUE = {
    caracteres: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u00c0\u00c2\u00c4\u00c7\u00c9\u00c8\u00ca\u00cb\u00ce\u00cf\u00d4\u00d6\u00d9\u00db\u00dc\u0178\u00e0\u00e2\u00e4\u00e7\u00e9\u00e8\u00ea\u00eb\u00ee\u00ef\u00f4\u00f6\u00f9\u00fb\u00fc\u00ff\u0153\u0152\u00e6\u00c6\u00a0\u202f\u2009\u00ab\u00bb\u2019\u2018\u201c\u201d\u2026\u2014\u2013\u00b0\u2032\u2033\u2212\u00b7\u00d7\u00f7\u00b1=<>\u03c0\u00b5\u03b1\u03b2\u03b8\u0394\u0398\u00b2\u00b3\u00b9\u2070\u2074\u2075\u2076\u2077\u2078\u2079\u207f',
    avances: [
        225, 290, 338, 573, 495, 711, 747, 189, 359, 357, 402, 730, 253, 312, 253, 395, 495, 495, 495,
        495, 495, 495, 494, 495, 495, 495, 253, 253, 711, 730, 711, 419, 926, 690, 613, 667, 718, 624,
        592, 706, 776, 358, 420, 678, 590, 900, 729, 720, 592, 720, 643, 543, 627, 743, 658, 940, 642,
        621, 616, 360, 413, 360, 480, 512, 231, 550, 515, 421, 552, 428, 307, 462, 566, 294, 287, 521,
        286, 843, 581, 502, 540, 532, 402, 384, 313, 572, 449, 724, 472, 466, 436, 331, 275, 331, 568,
        690, 690, 690, 667, 624, 624, 624, 624, 358, 358, 720, 720, 743, 743, 743, 621, 550, 550, 550,
        421, 428, 428, 428, 428, 294, 294, 502, 502, 572, 572, 572, 466, 735, 974, 715, 922, 225, 125,
        125, 532, 532, 240, 240, 428, 428, 880, 1000, 500, 401, 283, 459, 730, 286, 669, 607, 730, 730,
        711, 711, 590, 564, 566, 512, 516, 648, 733, 377, 377, 349, 425, 421, 363, 403, 366, 376, 405,
        511,
    ],
};
const AVANCES_TEXTE = {
    caracteres: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u00c0\u00c2\u00c4\u00c7\u00c9\u00c8\u00ca\u00cb\u00ce\u00cf\u00d4\u00d6\u00d9\u00db\u00dc\u0178\u00e0\u00e2\u00e4\u00e7\u00e9\u00e8\u00ea\u00eb\u00ee\u00ef\u00f4\u00f6\u00f9\u00fb\u00fc\u00ff\u0153\u0152\u00e6\u00c6\u00a0\u202f\u2009\u00ab\u00bb\u2019\u2018\u201c\u201d\u2026\u2014\u2013\u00b0\u2032\u2033\u2212\u00b7\u00d7\u00f7\u00b1=\u2260\u2248\u2264\u2265<>\u2192\u21d2\u21d4\u221e\u2211\u220f\u222b\u221a\u03c0\u00b5\u03b1\u03b2\u03b8\u0394\u0398\u00b2\u00b3\u00b9\u2070\u2074\u2075\u2076\u2077\u2078\u2079\u207f',
    avances: [
        281, 278, 403, 631, 638, 812, 639, 222, 362, 362, 500, 659, 280, 460, 276, 357, 625, 464, 605,
        636, 642, 608, 624, 571, 616, 624, 276, 280, 659, 659, 659, 507, 936, 676, 651, 727, 719, 598,
        587, 743, 740, 264, 543, 652, 562, 889, 753, 761, 635, 761, 639, 638, 642, 741, 676, 949, 642,
        665, 625, 362, 357, 362, 469, 452, 497, 564, 621, 558, 621, 582, 361, 609, 591, 237, 237, 544,
        237, 869, 585, 597, 609, 609, 372, 523, 364, 581, 557, 812, 540, 557, 541, 362, 327, 362, 659,
        676, 676, 676, 727, 598, 598, 598, 598, 264, 264, 761, 761, 741, 741, 741, 665, 564, 564, 564,
        558, 582, 582, 582, 582, 237, 237, 597, 597, 581, 581, 581, 557, 990, 953, 925, 990, 281, 182,
        182, 540, 540, 185, 199, 381, 381, 821, 1000, 500, 455, 220, 405, 659, 276, 659, 659, 659, 659,
        659, 659, 659, 659, 659, 659, 955, 955, 1341, 930, 631, 722, 278, 631, 631, 622, 641, 592, 540,
        676, 761, 420, 430, 313, 440, 436, 415, 425, 388, 428, 425, 403,
    ],
};
/**
 * Les signes de STIX Two Math (`STIXTwoMath-Symboles.ttf`). Les ensembles de
 * nombres `ℕ ℤ ℚ ℝ ℂ` (`\mathbb`) et `∘ δ ∠ △` y sont depuis le 17 octobre
 * 2026 : absents de TOUTES les polices embarquées, ils étaient dessinés dans
 * une police de repli du système (Menlo, Helvetica, ou celle d'iOS) à une
 * avance de 0,6 cadratin qui n'était pas la leur — et rognés par le cadre du
 * dessin, que `react-native-svg` ferme sur iOS. Chaque glyphe que le moteur
 * peut poser a désormais son avance ici (`metrique-couverture.test.ts`).
 */
const AVANCES_SYMBOLE = {
    caracteres: '\u2260\u2248\u2261\u2264\u2265\u2192\u21d2\u21d4\u21a6\u221e\u2208\u2209\u222a\u2229\u2225\u22a5\u22ef\u220b\u220c\u2115\u2124\u211a\u211d\u2102\u2218\u03b4\u2220\u25b3',
    avances: [
        720, 720, 720, 720, 720, 948, 887, 948, 948, 953, 720, 720, 636, 636, 535, 720, 953, 720, 720,
        692, 648, 751, 729, 695, 436, 479, 720, 1172,
    ],
};
/** La métrique des formules du manuel : la police que charge l'application. */
export const METRIQUE_MANUEL = metriqueProportionnelle({
    nom: 'stix-two',
    echelle: 1.1,
    montee: 0.66,
    oeil: 0.475,
    descente: 0.24,
    elevationExposant: 0.37,
    airScript: 0.03,
    correctionItalique: 0.035,
    airFraction: 0.07,
}, {
    droit: AVANCES_DROIT,
    italique: AVANCES_ITALIQUE,
    texte: AVANCES_TEXTE,
    symbole: AVANCES_SYMBOLE,
});
//# sourceMappingURL=metrique-police.js.map